export function AjaxContentException(message) {
    this.message = message;
    this.name = 'AjaxContentException';
}
